{
    "comment_slider.response": "argomento",
    "comment_slider.responses": "argomenti",
    "editorial_question.lets_talk": "Proponi una soluzione",
    "editorial_question.share_thoughts": "Condividi la tua soluzione",
    "login.continue_with": "Accedere con il Login SSR",
    "question.input_placeholder": "La sua soluzione:",
    "upvote.count": "Sostenuto {count}x"
}
